import React from 'react'
import {
    Layout
  } from "antd";

// Constants
import { ROOT_CONSTANT } from '../../constants'

const { THEME } = ROOT_CONSTANT
const { Header } = Layout;

const LoginHeader = () => {

    return (
        <Header style={{ backgroundColor: "#ffffff", textAlign: "center", height: 160 }}>
            <img
                alt=""
                src={THEME.MAIN_LOGO}
                style={{ height: "50%",  marginTop: 50 }}
            />
        </Header>
    )
}

export default LoginHeader;